import React from 'react';
import PropTypes from 'prop-types';
import { databaseContactWarning } from './shared';
import AddressFields from './address_fields';
import { Form } from 'react-bootstrap-5';

export default function CompanyContactForm({
  accessibleDatabaseContacts = [],
  areFieldsRequired,
  company,
  displayName,
  persistAddress,
  onAddressChange,
  onFieldChange,
  onToggleAddressFields
}) {
  const alreadyHasAddress = !!company?.address?.id;

  return (
    <React.Fragment>
      {databaseContactWarning(accessibleDatabaseContacts, displayName)}
      <Form.Group className="form-group">
        <Form.Label>
          Company name {areFieldsRequired && (<span className="text-danger">(Required)</span>)}
        </Form.Label>
        <input
          className="form-control"
          placeholder="Enter company name"
          type="text"
          value={company.name || ''}
          onChange={e => onFieldChange(e.target.value, 'name')}
        />
      </Form.Group>
      <Form.Group className="form-group">
        <Form.Label>Email</Form.Label>
        <input
          className="form-control"
          placeholder="Enter email"
          type="email"
          value={company.email || ''}
          onChange={e => onFieldChange(e.target.value, 'email')}
        />
      </Form.Group>
      <Form.Group className="form-group">
        <Form.Label>Phone Number</Form.Label>
        <input
          className="form-control"
          placeholder="Enter phone number"
          type="tel"
          value={company.phoneNumber || ''}
          onChange={e => onFieldChange(e.target.value, 'phoneNumber')}
        />
      </Form.Group>
      {!alreadyHasAddress && (
        <Form.Group className="form-group">
          <Form.Check
            checked={persistAddress}
            id="new-company-address"
            label="Add Primary Address"
            type="checkbox"
            onChange={onToggleAddressFields}
          />
        </Form.Group>
      )}

      <AddressFields address={company?.address || {}} showAddress={persistAddress} onChange={onAddressChange}/>
    </React.Fragment>
  );
}

CompanyContactForm.propTypes = {
  accessibleDatabaseContacts: PropTypes.array,
  areFieldsRequired: PropTypes.bool.isRequired,
  company: PropTypes.object.isRequired,
  displayName: PropTypes.string,
  persistAddress: PropTypes.bool.isRequired,
  onAddressChange: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onToggleAddressFields: PropTypes.func.isRequired
};
